/**
 * Created by shaik on 09/11/17.
 */
define(function (require) {
    window.lpTag = window.lpTag || {};

    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpUtils = require('utils/lpUtils');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');

    var TOKENIZER_DOMAIN_KEY = '{tokenizer}';
    var LOADING_TIMEOUT = 1000 * 30; // 30SEC
    var PCI_GENERATE_TOKEN_REDIRECT_PAGE = '/pcigw/pci_dynamic_token_le_submitted.html';
    var PCI_GENERATE_TOKEN_PAGE = '/pcigw/pci_dynamic_token_le.jsp';
    var VALIDATION_ID_PREFIX = 'dynamicValidationId-';

    var GenerateTokenViewController = ViewController.extend({
        ControllerName: "GenerateTokenViewController",

        LPViewMap: {
            wrapper: '.lpview_generate_token_dialog',
            closeDialogIcon: ".lpview_close_dialog",
            closeButton: ".lpview_close_button",
            copyToken: ".lpview_copy_token",
            tryAgainButton: ".lpview_try_again_button",
            iFrame: '.lpview_iframe_placeholder',
            tokenValue: '.lpview_token_value',
            inputTokenValue: '.lpview_input_token_value'
        },
        LPViewErrorMap: {
            errorMessageDefault: '.error_message_default',
            errorMessagePciCompliant: '.error_message_pci_compliant'
        },
        LPStateMaps: {
            init: 'init',
            loading: 'loading',
            error: 'error',
            success: 'success'
        },
        initialize: function (constructorData) {
            this.modelController = constructorData.modelController;
            this.tokenServerDomain = _getSourceOrigin();
            this.iframeElement = this.getFirstElement(this.LPViewMap.iFrame, this);

            this.onIFrameLoaded = _onIFrameLoaded.bind(this);
            this.onIFrameError = _onIFrameError.bind(this);
            this.onIFrameTimeOut = _onIFrameTimeOut.bind(this);

            this.errorTimeoutSiteSetting = lpTag.WebAgent.logicController.getGenerateTokenTimeoutSiteSettings();
        },
        events: function () {
            this.bindViewEvent({selector: this.LPViewMap.closeDialogIcon, DOMEvent: "click", callback: this.hideDialog});
            this.bindViewEvent({selector: this.LPViewMap.closeButton, DOMEvent: "click", callback: this.hideDialog});
            this.bindViewEvent({selector: this.LPViewMap.copyToken, DOMEvent: "click", callback: this.CopyToken});
            this.bindViewEvent({selector: this.LPViewMap.tryAgainButton, DOMEvent: "click", callback: this.showDialog});
        },
        render: function () {
        }
    });

    GenerateTokenViewController.prototype.showDialog = function () {
        this.lpShow();
        this.openGenerateTokenSearchForm();
    };

    GenerateTokenViewController.prototype.hideDialog = function () {
        this.iframeLoadingTimeout = null;
        this.removeBindings();
        this.unbindViewEvent({view: window, DOMEvent: "message", callback: this.onPostMessageReceived});
        this.lpHide();
        this.resetState();
    };

    GenerateTokenViewController.prototype.resetState = function () {
        var wrapper = this.getFirstElement(this.LPViewMap.wrapper);
        var stateClasses = [this.LPStateMaps.error, this.LPStateMaps.success, this.LPStateMaps.loading, this.LPStateMaps.init];
        this.removeClass(wrapper, stateClasses);
        this.addClass(wrapper, this.LPStateMaps.loading);
    };

    GenerateTokenViewController.prototype.CopyToken = function () {
        var copyElement = this.getFirstElement(this.LPViewMap.inputTokenValue);
        copyElement.select();
        document.execCommand("Copy");
    };

    GenerateTokenViewController.prototype.setErrorMessage = function (chosenElementMapping) {
        var self = this;
        _.each(self.LPViewErrorMap, function(errorMapping){
            if(errorMapping !== chosenElementMapping) {
                var errorElement = self.getFirstElement(errorMapping);
                if (errorElement) {
                    self.addClass(errorElement, 'hide');
                }
            }
        });

        var chosenError = this.getFirstElement(chosenElementMapping);
        if (chosenError) {
            this.removeClass(chosenError, 'hide');
        }
    };

    GenerateTokenViewController.prototype.openGenerateTokenSearchForm = function () {
        var self = this;
        var validationId = VALIDATION_ID_PREFIX + lpTag.WebAgent.logicController.getCurrentTime();
        var siteId = this.modelController.getModelParam('account');

        if (this.modelController.getModelParam(lpSecureFormsController.SECURE_FORMS_PCI_COMPILANT_SETTINGS_DATA_MODEL_PATH)) {
            lpTag.WebAgent.secureFormsController.requestGenerateTokenOTK({
                validationId: validationId ,
                success: onGenerateTokenOTKSuccess,
                error: onOTKError
            });
        } else {
            this.setErrorMessage(this.LPViewErrorMap.errorMessagePciCompliant);
            this.setState(this.LPStateMaps.error);
        }


        function onGenerateTokenOTKSuccess(data) {
            var urlParams = {
                siteid: siteId,
                otk: data.body.submitOtk,
                formOtk: data.body.formOtk,
                redirect: self.tokenServerDomain + PCI_GENERATE_TOKEN_REDIRECT_PAGE,
                otkJson: JSON.stringify([{"key": "validationId", "value": validationId}])
            };
            var url = getFullIframeURI(self.tokenServerDomain + PCI_GENERATE_TOKEN_PAGE, urlParams);
            self.setIFrame(url);
        }

        function onOTKError(err) {
            self.setState(self.LPStateMaps.error, 'request otk failed.', err);
        }

        function getFullIframeURI(url, params) {
            var paramsStr = "";
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    if (paramsStr !== "") {
                        paramsStr += "&";
                    }
                    paramsStr += key + "=" + encodeURIComponent(params[key]);
                }
            }
            return url + "?" + paramsStr;
        }
    };




    GenerateTokenViewController.prototype.setState = function (state, message) {
        var wrapper = this.getFirstElement(this.LPViewMap.wrapper);
        var stateClasses = [this.LPStateMaps.success, this.LPStateMaps.loading, this.LPStateMaps.error, this.LPStateMaps.init];
        var stateIndex = stateClasses.indexOf(state);
        if (stateIndex >= 0) {
            stateClasses.splice(stateIndex, 1);
        }

        this.removeClass(wrapper, stateClasses);
        this.addClass(wrapper, state);
    };

    GenerateTokenViewController.prototype.setGeneratedToken = function (token) {
        var textTokenElement = this.getFirstElement(this.LPViewMap.tokenValue);
        var finalToken = '"lp_search:' + token + '"';
        textTokenElement.innerText = finalToken;
        textTokenElement.textContent = finalToken;
        var inputTokenElement = this.getFirstElement(this.LPViewMap.inputTokenValue);
        inputTokenElement.value = finalToken;
    };

    GenerateTokenViewController.prototype.onPostMessageReceived = function (e) {
        if (e.source === this.iframeElement.contentWindow && e.origin === this.tokenServerDomain) {
            this.removeBindings();

            if (e.data && e.data.status === 'loaded') { //form loaded
                this.setState(this.LPStateMaps.init);
            }
            else if (e.data && e.data.status === 'submitted') { //form submitted
                this.setState(this.LPStateMaps.loading);
                this.iframeLoadingTimeout = setTimeout(this.onIFrameTimeOut, this.errorTimeoutSiteSetting || LOADING_TIMEOUT);
            }
            else if (e.data && e.data.status === 'success') { //token returned successfully
                this.setGeneratedToken(e.data.token);
                this.setState(this.LPStateMaps.success);
            }
            else {
                this.setState(this.LPStateMaps.error);
            }
        }
    };

    GenerateTokenViewController.prototype.setBindings = function () {
        this.unbindViewEvent({view: window, DOMEvent: "message", callback: this.onPostMessageReceived});
        this.bindViewEvent({view: window, DOMEvent: "message", callback: this.onPostMessageReceived});
        lpUtils.addEventListener(this.iframeElement, 'load', this.onIFrameLoaded);
        lpUtils.addEventListener(this.iframeElement, 'error', this.onIFrameError);
    };

    GenerateTokenViewController.prototype.removeBindings = function () {
        lpUtils.removeEventListener(this.iframeElement, 'load', this.onIFrameLoaded);
        lpUtils.removeEventListener(this.iframeElement, 'error', this.onIFrameError);
        this.removeTimeout();
    };

    GenerateTokenViewController.prototype.removeTimeout = function () {
        if (this.iframeLoadingTimeout) {
            clearTimeout(this.iframeLoadingTimeout);
            this.iframeLoadingTimeout = null;
        }
    };

    GenerateTokenViewController.prototype.setIFrame = function (url) {
        // setting the loading state.
        this.setBindings();

        // setting the 'SRC' attribute for the iframe element to trigger the loading.
        this.iframeElement.setAttribute('src', url);
        this.removeTimeout();
        this.iframeLoadingTimeout = setTimeout(this.onIFrameTimeOut, LOADING_TIMEOUT);
    };

    function _onIFrameLoaded() {
        this.setState(this.LPStateMaps.init);
    }

    function _onIFrameError() {
        this.setState(this.LPStateMaps.error, 'error when loading the IFrame.');
        this.removeTimeout();
    }

    function _onIFrameTimeOut() {
        this.setState(this.LPStateMaps.error, 'IFrame loading timed out.');
        this.iframeLoadingTimeout = null;

        // removing the listener to remove the response of the IFrame.
        // resetting the IFrame src.
        this.removeBindings();
        this.iframeElement.setAttribute('src', 'about:blank');
    }

    function _getSourceOrigin() {
        return agentLEManager.getLEUrlResolverGetUrl(TOKENIZER_DOMAIN_KEY).toLowerCase();
    }


    return GenerateTokenViewController;
});
